"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = require("./array");
var _unique = 0;
function unique(prefix) {
    if (prefix === void 0) { prefix = '_'; }
    return prefix + _unique++;
}
exports.unique = unique;
function randomIntBetween(a, b) {
    return Math.floor(Math.random() * b) + a;
}
exports.randomIntBetween = randomIntBetween;
function randomIntsBetween(l, min, max) {
    return array_1.array(l).map(function (n) { return randomFloatBetween(min, max); });
}
exports.randomIntsBetween = randomIntsBetween;
exports.ints = randomIntsBetween;
exports.int = randomIntBetween;
function randomFloatBetween(a, b) {
    return Math.random() * b + a;
}
exports.randomFloatBetween = randomFloatBetween;
function randomFloatsBetween(l, min, max) {
    return array_1.array(l).map(function (n) { return randomFloatBetween(min, max); });
}
exports.randomFloatsBetween = randomFloatsBetween;
exports.floats = randomFloatsBetween;
exports.float = randomFloatBetween;
/**
 * Makes sure n is between min and max inclusive.
 */
function between(n, min, max) {
    return Math.max(min, Math.min(n, max));
}
exports.between = between;
/**
 * Makes sure n is between min and max inclusive and is natural.
 */
function intBetween(n, min, max) {
    return Math.trunc(Math.max(min, Math.min(n, max)));
}
exports.intBetween = intBetween;
//# sourceMappingURL=number.js.map